var map = {
	"./backToTop.js": [
		"./assets/resources/js/modules/backToTop.js",
		"mod-backToTop-js"
	],
	"./calculator.js": [
		"./assets/resources/js/modules/calculator.js",
		"mod-calculator-js"
	],
	"./calculator/api.js": [
		"./assets/resources/js/modules/calculator/api.js",
		"mod-calculator-api-js"
	],
	"./calculator/i18n.js": [
		"./assets/resources/js/modules/calculator/i18n.js",
		"mod-calculator-i18n-js"
	],
	"./calculator/pdf.js": [
		"./assets/resources/js/modules/calculator/pdf.js",
		"mod-calculator-pdf-js"
	],
	"./header.js": [
		"./assets/resources/js/modules/header.js",
		"mod-header-js"
	],
	"./preloaderPage.js": [
		"./assets/resources/js/modules/preloaderPage.js",
		"mod-preloaderPage-js"
	],
	"./themeSwitcher.js": [
		"./assets/resources/js/modules/themeSwitcher.js",
		"mod-themeSwitcher-js"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./assets/resources/js/modules lazy recursive ^\\.\\/.*\\.js$";
module.exports = webpackAsyncContext;